function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.99 19.04l-7.37-5.73L3 14.57l9 7 9-7-1.63-1.27-7.38 5.74zM12 16.5l7.36-5.73L21 9.5l-9-7-9 7 1.63 1.27L12 16.5z",
  fill: "currentColor"
});

function SvgMapLayers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLayers);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5IDE5LjA0TDQuNjIgMTMuMzFMMyAxNC41N0wxMiAyMS41N0wyMSAxNC41N0wxOS4zNyAxMy4zTDExLjk5IDE5LjA0Wk0xMiAxNi41TDE5LjM2IDEwLjc3TDIxIDkuNUwxMiAyLjVMMyA5LjVMNC42MyAxMC43N0wxMiAxNi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };